<style scoped lang="scss">
@media screen and (max-width: 641px){
  .breads{
    display: none!important;
  }
}
.wrap-contact{
  margin-bottom: 80px;
}
  .contact{
    border: 1px solid #E4E6EA;
    display: flex;
    flex-wrap: wrap;
    li{
      width:50%;
      padding:30px;
      border-bottom: 1px solid #E4E6EA;
      &:nth-of-type(2n+1){
        border-right: 1px solid #E4E6EA;
      }
      &:last-child{
        border-bottom: 0;
      }
    }
    h3{
      color:#014492;
      font-size: 20px;
      margin-bottom: 10px;
    }
    p{
      font-size: 16px;
    }
  }
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .contact{
    display: block!important;
  }
  .contact p{
    font-size: 14px;
  }
  .contact h3{
    font-size: 18px;
  }
  .contact li{
    width: 100% !important;
  }
  .container{
    width: 90% !important;
  }
}
</style>
<template>
  <div class="wrap-contact" id="wrap-contact" ref="wrapContact">
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
      <bread></bread>
    </div>
    <div class="c-title">联系我们</div>
    <div class="container">
      <ul class="contact">
        <li v-for="(item, index) in pageData.contact" :key="index">
          <h3>{{item.name}}</h3>
          <p>{{item.address}}</p>
          <p>{{item.zipCode}}</p>
          <p>{{item.tel}}</p>
          <p>{{item.email}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['pageData'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
         if(to.name=='SummaryContact' && !from.path.includes('/summary/')){
            setTimeout(()=>{
               vm.$refs.wrapContact && vm.$refs.wrapContact.scrollIntoView(true)
               vm.$nextTick(()=>{
                vm.$refs.wrapContact && (document.documentElement.scrollTop = document.documentElement.scrollTop-50)
               })
            },200)
           
        }
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/views/summary/contact.vue